export default __webpack_public_path__ + "static/xc40-454c17a1f932ab205f5ae514cfd22db4.png";